export const DATA_SOURCE_ASSUMPTIONS = 'assumptions'
export const DATA_SOURCE_HIRING_PLAN = 'hiringPlan'
export const DATA_SOURCE_KNOWN_EMPLOYEES = 'knownEmployees'
